import React, { useState, useEffect, useRef, useCallback } from 'react';
import api from '../../utils/api';

const FORM_W = 265;
const FORM_H = 270;

const DEFAULTS = {
  fields: {
    acctLabel:    { x:2,   y:37.8, text:'Account Number',                           size:6,  bold:false, gray:true  },
    acctValue:    { x:2,   y:44.5, text:'R08J70',                                   size:8,  bold:false, gray:false },
    ecLabel:      { x:79,  y:37.8, text:'Emergency Contact Number',                  size:6,  bold:false, gray:true  },
    ecValue:      { x:79,  y:44.5, text:'3307304698',                               size:8,  bold:false, gray:false },
    refLabel:     { x:2,   y:55.0, text:'Reference Number',                          size:6,  bold:false, gray:true  },
    refValue:     { x:2,   y:64.5, text:'1ZR08J700310756960',                        size:7,  bold:false, gray:false },
    erLabel:      { x:79,  y:55.0, text:'ER Registrant',                             size:6,  bold:false, gray:true  },
    erValue:      { x:79,  y:64.5, text:'Summit Fishing Equipment',                  size:7,  bold:false, gray:false },
    xxxx:         { x:202, y:63.0, text:'XXXX',                                      size:7,  bold:false, gray:false },
    descLabel:    { x:2,   y:73.5, text:'Hazardous Materials Description and Quantity', size:6, bold:false, gray:true },
    hazPlus:      { x:210, y:74.5, text:'HAZ+',                                      size:8,  bold:true,  gray:false },
    descValue:    { x:2,   y:84.0, text:'UN3480, LITHIUM ION BATTERY, 9, 1 FiberboardBox x 8 LB', size:7, bold:false, gray:false },
        certText:     { x:2,   y:193,  text:'For Air Shipments, "I declare that all of the applicable air transport requirements have been met". I hereby declare that the contents of this consignment are fully and accurately described above by the proper shipping name and are classified, packaged, marked and labelled/ placarded, and are in all respects in proper condition for transport according to applicable international and national governmental regulations. If this shipment contains radioactive material acceptable for passenger aircraft, such material is intended for use in, or incident to, research, medical diagnosis or treatment.',  size:6,  bold:false, gray:false  },
    carrierLabel: { x:185, y:194,  text:'Carrier Use Only',                           size:7,  bold:true,  gray:false },
    initialsLabel:{ x:185, y:206,  text:'Initials',                                   size:6,  bold:false, gray:true  },
    slicLabel:    { x:185, y:222,  text:'SLIC',                                       size:6,  bold:false, gray:true  },
    dateRLabel:   { x:185, y:238,  text:'Date',                                       size:6,  bold:false, gray:true  },
    signerValue:  { x:2,   y:246,  text:'Todd Dye',                                   size:8,  bold:false, gray:false },
    dateValue:    { x:149, y:246,  text:'10/05/2026',                                 size:8,  bold:false, gray:false },
    sigLabel:     { x:44,  y:257,  text:'Signature',                                  size:6,  bold:false, gray:true  },
    dateLLabel:   { x:156, y:257,  text:'Date',                                       size:6,  bold:false, gray:true  },
  },
  lines: [
    { id:'row1bot',  x1:0,   y:52.0, x2:265, vertical:false },
    { id:'row2bot',  x1:0,   y:70.0, x2:265, vertical:false },
    { id:'vdiv',     x1:77,  y:35.8, x2:77,  vertical:true,  y2:70.0  },
    { id:'vcarrier', x1:183, y:192,  x2:183, vertical:true,  y2:260.0 },
    { id:'initline', x1:185, y:214,  x2:265, vertical:false },
    { id:'slicline', x1:185, y:230,  x2:265, vertical:false },
    { id:'dateline', x1:185, y:246,  x2:265, vertical:false },
    { id:'sigbot',   x1:0,   y:260,  x2:265, vertical:false },
    { id:'sigline',  x1:2,   y:254,  x2:180, vertical:false },
  ]
};

function getLayoutJson(state) {
  const f = state.fields;
  const l = id => state.lines.find(x => x.id === id);
  return {
    r1_top: f.acctLabel.y,   r1_val: f.acctValue.y,
    r1_bot: l('row1bot').y,  r1_bot_x2: l('row1bot').x2,
    ec_x:   f.ecLabel.x,
    r2_top: f.refLabel.y,    r2_val: f.refValue.y,
    r2_bot: l('row2bot').y,  r2_bot_x2: l('row2bot').x2,
    xxxx_x: f.xxxx.x,        xxxx_y: f.xxxx.y,
    d_top:  f.descLabel.y,   d_val:  f.descValue.y,
    haz_x:  f.hazPlus.x,     haz_y:  f.hazPlus.y,
    sig_top: f.certText.y,   carrier_x: l('vcarrier').x1,
    sig_bot: l('sigbot').y,  sig_bot_x2: l('sigbot').x2,
    init_y: l('initline').y, init_x1: l('initline').x1, init_x2: l('initline').x2,
    slic_y: l('slicline').y, slic_x1: l('slicline').x1, slic_x2: l('slicline').x2,
    dater_y: l('dateline').y, dater_x1: l('dateline').x1, dater_x2: l('dateline').x2,
    signer_y: f.signerValue.y, dateval_x: f.dateValue.x, dateval_y: f.dateValue.y,
    sigline_y: l('sigline').y, sigline_x1: l('sigline').x1, sigline_x2: l('sigline').x2,
    siglabel_x: f.sigLabel.x,   siglabel_y: f.sigLabel.y,
    datelabel_x: f.dateLLabel.x, datelabel_y: f.dateLLabel.y,
    vcarrier_y: l('vcarrier').y, vcarrier_y2: l('vcarrier').y2,
    vdiv_x: l('vdiv').x1, vdiv_y: l('vdiv').y, vdiv_y2: l('vdiv').y2,
    cert_text: f.certText.text, cert_size: f.certText.size,
    fs_label:   f.acctLabel.size,
    fs_value:   f.acctValue.size,
    fs_ref:     f.refValue.size,
    fs_desc:    f.descValue.size,
    fs_xxxx:    f.xxxx.size,
    fs_haz:     f.hazPlus.size,
    fs_carrier: f.carrierLabel.size,
    fs_signer:  f.signerValue.size,
    fs_sublbl:  f.sigLabel.size,
    extra_lines: state.lines.filter(ln => ln.id.startsWith('line_')).map(ln => ({
      id: ln.id, x1: ln.x1, y: ln.y, x2: ln.x2, vertical: ln.vertical, y2: ln.y2
    })),
  };
}

const CERT_LINES = [
  'For Air Shipments, "I declare that all of the applicable air',
  'transport requirements have been met". I hereby declare that',
  'the contents of this consignment are fully and accurately',
  'described above by the proper shipping name and are classified,',
  'packaged, marked and labelled/ placarded, and are in all',
  'respects in proper condition for transport according to',
  'applicable international and national governmental regulations.',
  'If this shipment contains radioactive material acceptable for',
  'passenger aircraft, such material is intended for use in, or',
  'incident to, research, medical diagnosis or treatment.',
];

export default function HazMatFormEditor() {
  const canvasRef  = useRef(null);
  const [state, setState]     = useState(() => JSON.parse(JSON.stringify(DEFAULTS)));
  const [selected, setSelected] = useState(null);
  const [zoom, setZoom]       = useState(2.5);
  const [grid, setGrid]       = useState(false);
  const [status, setStatus]   = useState('Ready — drag fields and lines to reposition');
  const [saving, setSaving]   = useState(false);
  const [generating, setGenerating] = useState(false);
  const dragging  = useRef(null);
  const dragStart = useRef(null);
  const [certDraft, setCertDraft] = useState(null);

  // Load saved layout
  useEffect(() => {
    api.get('/api/shipping/settings').then(({ data }) => {
      if (data.hazmat_form_layout && data.hazmat_form_layout !== 'PASTE_JSON_HERE') {
        try {
          const saved = JSON.parse(data.hazmat_form_layout);
          // New format: full canvas state stored directly
          if (saved && saved._canvas_state) {
            setState(prev => ({
              ...prev,
              fields: { ...prev.fields, ...saved._canvas_state.fields },
              lines: saved._canvas_state.lines || prev.lines,
            }));
          }
        } catch(e) { console.warn('Layout parse error', e); }
      }
    }).catch(() => {});
  }, []);

  const draw = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const W = FORM_W * zoom;
    const H = FORM_H * zoom;
    canvas.width  = W;
    canvas.height = H;
    const ctx = canvas.getContext('2d');
    const pt  = v => v * zoom;

    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, W, H);

    if (grid) {
      ctx.strokeStyle = 'rgba(100,100,255,0.2)';
      ctx.lineWidth = 0.5;
      for (let x = 0; x <= FORM_W; x += 10) { ctx.beginPath(); ctx.moveTo(pt(x),0); ctx.lineTo(pt(x),H); ctx.stroke(); }
      for (let y = 0; y <= FORM_H; y += 10) { ctx.beginPath(); ctx.moveTo(0,pt(y)); ctx.lineTo(W,pt(y)); ctx.stroke(); }
    }

    // Lines
    state.lines.forEach(l => {
      const isSel = selected === 'line:' + l.id;
      ctx.strokeStyle = isSel ? '#e94560' : '#000';
      ctx.lineWidth   = isSel ? 2 : 1;
      ctx.beginPath();
      if (l.vertical) { ctx.moveTo(pt(l.x1), pt(l.y)); ctx.lineTo(pt(l.x1), pt(l.y2 || l.y + 60)); }
      else             { ctx.moveTo(pt(l.x1), pt(l.y)); ctx.lineTo(pt(l.x2),  pt(l.y)); }
      ctx.stroke();
      if (isSel) {
        ctx.fillStyle = 'rgba(233,69,96,0.12)';
        if (l.vertical) ctx.fillRect(pt(l.x1)-5, pt(l.y), 10, pt((l.y2||l.y+60)-l.y));
        else            ctx.fillRect(pt(l.x1), pt(l.y)-5, pt(l.x2-l.x1), 10);
      }
    });

    // Fields
    Object.entries(state.fields).forEach(([key, f]) => {
      const isSel = selected === 'field:' + key;
      const px = pt(f.x), py = pt(f.y);
      ctx.font      = `${f.bold ? 'bold ' : ''}${pt(f.size)}px Helvetica, Arial, sans-serif`;
      ctx.fillStyle = f.gray ? '#888' : '#000';

      if (key === 'certText') {
        ctx.font = `${pt(f.size)}px Helvetica, Arial, sans-serif`;
        ctx.fillStyle = '#555';
        // Auto-wrap to fill available width up to carrier column
        const carrierLine = state.lines.find(l => l.id === 'vcarrier');
        const maxW = pt((carrierLine ? carrierLine.x1 : 183) - f.x - 4);
        const words = String(f.text || '').replace(/\\n/g, ' ').split(' ');
        const lines = [];
        let cur = '';
        words.forEach(w => {
          const test = cur ? cur + ' ' + w : w;
          if (ctx.measureText(test).width > maxW && cur) { lines.push(cur); cur = w; }
          else cur = test;
        });
        if (cur) lines.push(cur);
        const lineH = pt(f.size * 1.35);
        lines.forEach((line, i) => ctx.fillText(line, pt(f.x), pt(f.y) + i * lineH));
        if (isSel) { ctx.strokeStyle='#e94560'; ctx.lineWidth=1; ctx.strokeRect(pt(f.x)-2, pt(f.y)-pt(f.size+2), maxW+4, lines.length * lineH + 4); }
      } else {
        ctx.fillText(f.text, px, py);
        if (isSel) {
          const tw = ctx.measureText(f.text).width;
          ctx.fillStyle = 'rgba(233,69,96,0.15)';
          ctx.fillRect(px-2, py-pt(f.size)-2, tw+6, pt(f.size)+5);
          ctx.strokeStyle = '#e94560'; ctx.lineWidth = 1;
          ctx.strokeRect(px-2, py-pt(f.size)-2, tw+6, pt(f.size)+5);
        }
      }
    });
  }, [state, selected, zoom, grid]);

  useEffect(() => { draw(); }, [draw]);

  // Arrow key nudge
  useEffect(() => {
    const handler = e => {
      if (!selected) return;
      if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key)) return;
      e.preventDefault();
      const d = e.shiftKey ? 5 : 0.5;
      const r = v => Math.round(v * 10) / 10;
      setState(prev => {
        const next = JSON.parse(JSON.stringify(prev));
        if (selected.startsWith('field:')) {
          const k = selected.slice(6);
          if (e.key === 'ArrowLeft')  next.fields[k].x = r(next.fields[k].x - d);
          if (e.key === 'ArrowRight') next.fields[k].x = r(next.fields[k].x + d);
          if (e.key === 'ArrowUp')    next.fields[k].y = r(next.fields[k].y - d);
          if (e.key === 'ArrowDown')  next.fields[k].y = r(next.fields[k].y + d);
        } else if (selected.startsWith('line:')) {
          const id = selected.slice(5);
          const idx = next.lines.findIndex(l => l.id === id);
          const l = next.lines[idx];
          if (l.vertical) {
            const dx = e.key==='ArrowLeft' ? -d : e.key==='ArrowRight' ? d : 0;
            next.lines[idx].x1 = r(l.x1 + dx); next.lines[idx].x2 = next.lines[idx].x1;
          } else {
            const dy = e.key==='ArrowUp' ? -d : e.key==='ArrowDown' ? d : 0;
            next.lines[idx].y = r(l.y + dy);
          }
        }
        return next;
      });
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [selected]);

  function hitTest(mx, my) {
    const x = mx / zoom, y = my / zoom;
    for (let i = state.lines.length - 1; i >= 0; i--) {
      const l = state.lines[i];
      if (l.vertical) {
        const y1 = Math.min(l.y, l.y2||l.y+60), y2 = Math.max(l.y, l.y2||l.y+60);
        if (Math.abs(x - l.x1) < 5 && y >= y1-4 && y <= y2+4) return 'line:' + l.id;
      } else {
        if (Math.abs(y - l.y) < 5 && x >= l.x1-4 && x <= l.x2+4) return 'line:' + l.id;
      }
    }
    const entries = Object.entries(state.fields);
    for (let i = entries.length-1; i >= 0; i--) {
      const [key, f] = entries[i];
      const textW = key === 'certText' ? 178 : f.text.length * f.size * 0.55 + 8;
      if (x >= f.x-3 && x <= f.x+textW && y >= f.y-f.size-2 && y <= f.y+4) return 'field:' + key;
    }
    return null;
  }

  function onMouseDown(e) {
    const rect = canvasRef.current.getBoundingClientRect();
    const hit  = hitTest(e.clientX - rect.left, e.clientY - rect.top);
    setSelected(hit || null);
    if (hit === 'field:certText') setCertDraft(String(state.fields.certText.text || ''));
    if (hit) { dragging.current = hit; dragStart.current = { x: e.clientX, y: e.clientY }; }
  }

  function onMouseMove(e) {
    if (!dragging.current || !dragStart.current) return;
    const dx = (e.clientX - dragStart.current.x) / zoom;
    const dy = (e.clientY - dragStart.current.y) / zoom;
    dragStart.current = { x: e.clientX, y: e.clientY };
    const r = v => Math.round(v * 10) / 10;
    setState(prev => {
      const next = JSON.parse(JSON.stringify(prev));
      const id = dragging.current;
      if (id.startsWith('field:')) {
        const k = id.slice(6);
        next.fields[k].x = r(next.fields[k].x + dx);
        next.fields[k].y = r(next.fields[k].y + dy);
      } else if (id.startsWith('line:')) {
        const lid = id.slice(5);
        const idx = next.lines.findIndex(l => l.id === lid);
        if (next.lines[idx].vertical) {
          next.lines[idx].x1 = r(next.lines[idx].x1 + dx);
          next.lines[idx].x2 = next.lines[idx].x1;
        } else {
          next.lines[idx].y = r(next.lines[idx].y + dy);
        }
      }
      return next;
    });
  }

  function onMouseUp() { dragging.current = null; dragStart.current = null; }

  const selField = selected?.startsWith('field:') ? state.fields[selected.slice(6)] : null;
  const selLine  = selected?.startsWith('line:')  ? state.lines.find(l => l.id === selected.slice(5)) : null;

  function updateField(prop, val) {
    const k = selected.slice(6);
    setState(prev => { const n = JSON.parse(JSON.stringify(prev)); n.fields[k][prop] = prop === 'text' ? String(val) : (parseFloat(val)||0); return n; });
  }
  function updateLine(prop, val) {
    const id = selected.slice(5);
    setState(prev => { const n = JSON.parse(JSON.stringify(prev)); const idx = n.lines.findIndex(l=>l.id===id); n.lines[idx][prop] = parseFloat(val)||0; return n; });
  }
  function nudgeField(prop, d) { if (selField) updateField(prop, Math.round((selField[prop]+d)*10)/10); }
  function nudgeLine(prop, d)  { if (selLine)  updateLine(prop,  Math.round(((selLine[prop]||0)+d)*10)/10); }

  function addLine() {
    const id = 'line_' + Date.now();
    setState(prev => ({
      ...prev,
      lines: [...prev.lines, { id, x1:0, y:100, x2:265, vertical:false }]
    }));
    setTimeout(() => setSelected('line:' + id), 50);
    setStatus('New line added — drag to position, use X1/X2 to set length');
  }

  async function saveLayout() {
    setSaving(true);
    setStatus('Saving...');
    try {
      const payload = {
        ...getLayoutJson(state),
        _canvas_state: { fields: state.fields, lines: state.lines },
      };
      console.log('Saving layout:', JSON.stringify(payload).substring(0, 100));
      const resp = await api.patch('/api/shipping/settings', { hazmat_form_layout: JSON.stringify(payload) });
      console.log('Save response:', resp.status, resp.data);
      setStatus('✓ Layout saved! r1_top=' + payload.r1_top + ' r2_top=' + payload.r2_top);
    } catch(e) {
      console.error('Save error:', e);
      setStatus('Save failed: ' + (e.response?.data?.error || e.message));
    }
    setSaving(false);
  }

  async function generatePdf() {
    setGenerating(true);
    setStatus('Generating PDF...');
    try {
      const token = localStorage.getItem('sf_token') || '';
      const resp = await fetch('/api/shipping/hazmat-form-preview', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ layout: getLayoutJson(state) }),
      });
      if (!resp.ok) throw new Error('HTTP ' + resp.status);
      const blob = await resp.blob();
      window.open(URL.createObjectURL(blob), '_blank');
      setStatus('✓ PDF opened in new tab — print on pre-printed stock to check alignment');
    } catch(e) { setStatus('Generate failed: ' + e.message); }
    setGenerating(false);
  }

  const NudgeRow = ({ label, val, onInc, onDec, onSet }) => (
    <div style={{ display:'flex', alignItems:'center', gap:4, marginBottom:6 }}>
      <span style={{ fontSize:11, color:'var(--text-secondary)', width:36 }}>{label}</span>
      <button onClick={onDec} style={{ padding:'1px 6px', border:'1px solid var(--border)', borderRadius:3, cursor:'pointer', fontSize:13 }}>−</button>
      <input type="number" step="0.5" value={val}
        onChange={e => onSet(e.target.value)}
        style={{ width:62, padding:'2px 5px', border:'1px solid var(--border)', borderRadius:3, fontSize:12, textAlign:'center' }}/>
      <button onClick={onInc} style={{ padding:'1px 6px', border:'1px solid var(--border)', borderRadius:3, cursor:'pointer', fontSize:13 }}>+</button>
    </div>
  );

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%', overflow:'hidden' }}>
      {/* Toolbar */}
      <div style={{ display:'flex', gap:8, padding:'10px 16px', borderBottom:'1px solid var(--border)', flexShrink:0, flexWrap:'wrap', alignItems:'center' }}>
        <span style={{ fontWeight:600, fontSize:14 }}>HazMat Form Editor</span>
        <button className="btn btn-primary" onClick={generatePdf} disabled={generating}>
          <i className="ti ti-file-type-pdf"/> {generating ? 'Generating…' : 'Generate Test PDF'}
        </button>
        <button className="btn btn-sm" onClick={saveLayout} disabled={saving}>
          <i className="ti ti-device-floppy"/> {saving ? 'Saving…' : 'Save Layout'}
        </button>
        <button className="btn btn-sm" onClick={() => setZoom(z => Math.min(z+0.5, 5))}>🔍+</button>
        <button className="btn btn-sm" onClick={() => setZoom(z => Math.max(z-0.5, 1))}>🔍−</button>
        <button className="btn btn-sm" onClick={() => setGrid(g => !g)}>{grid ? '⊞ Grid On' : '⊟ Grid Off'}</button>
        <button className="btn btn-sm" onClick={() => { if(window.confirm('Reset to defaults?')) { setState(JSON.parse(JSON.stringify(DEFAULTS))); setSelected(null); }}}>↺ Reset</button>
        <button className="btn btn-sm" onClick={addLine}>+ Add Line</button>
        <span style={{ fontSize:11, color:'var(--text-secondary)' }}>Arrow keys nudge 0.5pt (Shift=5pt)</span>
      </div>

      <div style={{ display:'flex', flex:1, overflow:'hidden' }}>
        {/* Canvas */}
        <div style={{ flex:1, overflow:'auto', background:'#1a1a2e', display:'flex', justifyContent:'center', padding:20, alignItems:'flex-start' }}>
          <canvas ref={canvasRef}
            style={{ cursor: dragging.current ? 'grabbing' : 'crosshair', boxShadow:'0 4px 30px rgba(0,0,0,0.5)' }}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseUp}
          />
        </div>

        {/* Sidebar */}
        <div style={{ width:260, background:'var(--surface-1)', borderLeft:'1px solid var(--border)', overflow:'auto', padding:12, flexShrink:0 }}>
          {/* Selected item controls */}
          <div style={{ background:'var(--surface-2)', borderRadius:8, padding:10, marginBottom:12 }}>
            <div style={{ fontSize:12, fontWeight:600, marginBottom:8, color: selected ? 'var(--text-primary)' : 'var(--text-tertiary)' }}>
              {selected ? selected.replace('field:','').replace('line:','') : 'Click a field or line'}
            </div>
            {selField && (<>
              <NudgeRow label="X" val={selField.x} onDec={()=>nudgeField('x',-0.5)} onInc={()=>nudgeField('x',0.5)} onSet={v=>updateField('x',v)}/>
              <NudgeRow label="Y" val={selField.y} onDec={()=>nudgeField('y',-0.5)} onInc={()=>nudgeField('y',0.5)} onSet={v=>updateField('y',v)}/>
              <NudgeRow label="Size" val={selField.size} onDec={()=>nudgeField('size',-0.5)} onInc={()=>nudgeField('size',0.5)} onSet={v=>updateField('size',v)}/>
              {selected === 'field:certText' && (
                <div style={{ marginTop:6 }}>
                  <div style={{ fontSize:11, color:'var(--text-secondary)', marginBottom:3 }}>Cert Text</div>
                  <textarea
                    value={certDraft !== null ? certDraft : String(selField.text || '')}
                    onChange={e => setCertDraft(e.target.value)}
                    onBlur={e => { updateField('text', e.target.value); }}
                    rows={6}
                    style={{ width:'100%', fontSize:10, fontFamily:'monospace', padding:4,
                      border:'1px solid var(--border)', borderRadius:4, resize:'vertical' }}
                  />
                  <button onClick={() => { if (certDraft !== null) { updateField('text', certDraft); } }}
                    style={{ marginTop:4, width:'100%', padding:'3px 8px', border:'1px solid var(--border)',
                      borderRadius:4, cursor:'pointer', fontSize:11 }}>
                    Apply Text
                  </button>
                </div>
              )}
            </>)}
            {selLine && (<>
              <NudgeRow label="Y" val={selLine.y} onDec={()=>nudgeLine('y',-0.5)} onInc={()=>nudgeLine('y',0.5)} onSet={v=>updateLine('y',v)}/>
              {selLine.vertical && <>
                <NudgeRow label="X" val={selLine.x1} onDec={()=>nudgeLine('x1',-0.5)} onInc={()=>nudgeLine('x1',0.5)} onSet={v=>{updateLine('x1',v); updateLine('x2',v);}}/>
                <NudgeRow label="Y2" val={selLine.y2||0} onDec={()=>nudgeLine('y2',-0.5)} onInc={()=>nudgeLine('y2',0.5)} onSet={v=>updateLine('y2',v)}/>
              </>}
              {!selLine.vertical && <>
                <NudgeRow label="X1" val={selLine.x1} onDec={()=>nudgeLine('x1',-0.5)} onInc={()=>nudgeLine('x1',0.5)} onSet={v=>updateLine('x1',v)}/>
                <NudgeRow label="X2" val={selLine.x2} onDec={()=>nudgeLine('x2',-0.5)} onInc={()=>nudgeLine('x2',0.5)} onSet={v=>updateLine('x2',v)}/>
              </>}
              {selected?.startsWith('line:') && !selected.slice(5).startsWith('line_') && (
                <button onClick={() => {
                  const id = selected.slice(5);
                  setState(prev => {
                    const n = JSON.parse(JSON.stringify(prev));
                    const idx = n.lines.findIndex(l=>l.id===id);
                    const l = n.lines[idx];
                    if (l.vertical) { n.lines[idx].y2 = l.y; } // y2=y means zero height
                    else { n.lines[idx].x2 = l.x1; } // x2=x1 means zero width
                    return n;
                  });
                }} style={{ marginTop:6, padding:'3px 8px', border:'1px solid #e67e22', borderRadius:4, color:'#e67e22', cursor:'pointer', fontSize:11, width:'100%' }}>
                  👁 Hide Line
                </button>
              )}
              {selected?.startsWith('line:') && selected.slice(5).startsWith('line_') && (
                <button onClick={() => {
                  const id = selected.slice(5);
                  setState(prev => ({ ...prev, lines: prev.lines.filter(l => l.id !== id) }));
                  setSelected(null);
                }} style={{ marginTop:6, padding:'3px 8px', border:'1px solid #e74c3c', borderRadius:4, color:'#e74c3c', cursor:'pointer', fontSize:11, width:'100%' }}>
                  🗑 Delete Line
                </button>
              )}
            </>)}
          </div>

          {/* Field list */}
          <div style={{ fontSize:11, fontWeight:600, color:'var(--text-secondary)', marginBottom:6, textTransform:'uppercase' }}>Text Fields</div>
          {Object.keys(state.fields).map(key => (
            <div key={key} onClick={() => { setSelected('field:'+key); if (key==='certText') setCertDraft(String(state.fields.certText.text||'')); }}
              style={{ padding:'4px 8px', borderRadius:4, cursor:'pointer', fontSize:11, marginBottom:2,
                borderLeft:'3px solid #2ecc71',
                background: selected === 'field:'+key ? 'var(--primary-light, #e3f2fd)' : 'transparent',
                fontWeight: selected === 'field:'+key ? 600 : 'normal' }}>
              {key}
            </div>
          ))}

          <div style={{ fontSize:11, fontWeight:600, color:'var(--text-secondary)', marginBottom:6, marginTop:12, textTransform:'uppercase' }}>Lines</div>
          {state.lines.map(l => (
            <div key={l.id} onClick={() => setSelected('line:'+l.id)}
              style={{ padding:'4px 8px', borderRadius:4, cursor:'pointer', fontSize:11, marginBottom:2,
                borderLeft:'3px solid #3498db',
                background: selected === 'line:'+l.id ? 'var(--primary-light, #e3f2fd)' : 'transparent',
                fontWeight: selected === 'line:'+l.id ? 600 : 'normal' }}>
              {l.id} {l.vertical ? '(vert)' : '(horiz)'}
            </div>
          ))}
        </div>
      </div>

      {/* Status bar */}
      <div style={{ padding:'4px 16px', fontSize:11, color:'var(--text-secondary)', borderTop:'1px solid var(--border)', flexShrink:0, background:'var(--surface-1)' }}>
        {status} | Zoom: {zoom}x
      </div>
    </div>
  );
}
